import { render, staticRenderFns } from "./StartUpWizard.vue?vue&type=template&id=89cc6534&scoped=true"
import script from "./StartUpWizard.vue?vue&type=script&lang=js"
export * from "./StartUpWizard.vue?vue&type=script&lang=js"
import style0 from "./StartUpWizard.vue?vue&type=style&index=0&id=89cc6534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cc6534",
  null
  
)

export default component.exports